import * as api from "@/api";
import makeListingMixin from "@lab/store/vuexListingMixin";
import format from "date-fns/format";

export default makeListingMixin(
	"organisationListing",
	api.organisationListings
)({
	actions: {
		async organisationUserExport(context, { id, name }) {
			try {
				// TODO: use code from vacancytype.js
				// 				FileSaver.saveAs(pdfFile, filename);
				// 1. call the api call for exporting listing users
				let csv = await api.exportOrganisationUsers(id);

				// 2. create the filename for downloading
				name = name.replace(/\s+/g, "-").toLowerCase();
				const date = format(new Date(), "ddMMyyyy_HHmmss");
				const filename = `${name}-users-${date}.csv`;

				// 3. Check to see if the api call has text/csv headers attached. If not apply.
				if (!csv.match(/^data:text\/csv/i)) {
					csv = "data:text/csv;charset=utf-8," + csv;
				}

				// 4. encode the text string
				const data = encodeURI(csv);

				// 5. creating a element to mimic a user clicking an link in the page.
				const link = document.createElement("a");
				link.setAttribute("href", data);
				link.setAttribute("download", filename);

				// 6. trigger a click event forcing the browser to download the created file.
				link.click();
			} catch (error) {
				// Just rethrowing error for the moment.
				// will set isFetching to be false here though
				console.log(error);
				throw error;
			}
			// console.log(context);
		}
	}
});
